/**
 * «Первая линия — Тоня» — ДЕМО.
 * Витрина будущей ценности: как работает умный цифровой сотрудник первой линии.
 * Пайпа диалогов из ops-app пока нет — весь блок приглушён и помечен «демо»,
 * чтобы основатель видел дорожную карту, но не принял демо-цифру за факт.
 */

import { MessageSquare, Timer } from 'lucide-react'
import { KpiCard, ProgressRing } from './primitives'
import { Card, CardContent } from '@/components/ui/card'
import type { DashboardTonya } from '@/types'

export function TonyaDemo({ tonya }: { tonya: DashboardTonya }) {
  const after = (suffix: string) => `демо · появится после ${suffix}`

  return (
    <div className="grid grid-cols-2 gap-4 opacity-90 lg:grid-cols-5">
      <KpiCard
        label="Диалогов сегодня"
        value={tonya.dialogs_today}
        icon={MessageSquare}
        demo
        demoLabel={after('подключения диалогов из ops-app')}
      />
      <KpiCard
        label="Среднее время ответа"
        value={`${tonya.avg_response_time_s} сек`}
        icon={Timer}
        demo
        demoLabel={after('подключения диалогов')}
      />
      <Card className="border-dashed bg-muted/40">
        <CardContent className="flex flex-col items-center p-4">
          <ProgressRing
            value={tonya.autoreply_rate}
            label={`${Math.round(tonya.autoreply_rate * 100)}%`}
            caption="Автоответов 24/7"
            demo
            size={84}
          />
        </CardContent>
      </Card>
      <Card className="border-dashed bg-muted/40">
        <CardContent className="flex flex-col items-center p-4">
          <ProgressRing
            value={tonya.escalation_rate}
            label={`${Math.round(tonya.escalation_rate * 100)}%`}
            caption="Эскалаций оператору"
            demo
            size={84}
          />
        </CardContent>
      </Card>
      <Card className="border-dashed bg-muted/40">
        <CardContent className="flex flex-col items-center p-4">
          <ProgressRing
            value={tonya.csat / 5}
            label={tonya.csat.toFixed(1)}
            caption="Удовлетворённость (CSAT) из 5"
            demo
            size={84}
          />
        </CardContent>
      </Card>
    </div>
  )
}
